import { IMessage, IUser } from "@/lib/types";
import { AvatarPixel } from "@/components/ui/avatar";
import { UserDocument } from "@/components/mainchat/userdocument";
import { UserImage } from "@/components/mainchat/userimage";
import Markdown from "react-markdown";

interface UserMessageProps {
    message: IMessage;
    user: IUser;
}

export const UserMessage = ({ message, user }: UserMessageProps) => {
    return (
        <div className={"flex flex-row justify-end"}>
            <div className={"flex-none flex flex-row items-start"}>
                <div className={"hidden lg:block lg:w-[24px] lg:h-1 lg:mr-[14px]"}>&nbsp;</div>
                <div className={"flex flex-col items-end"}>
                    {message.content.map((content, idx) => (
                        <div key={`content-${idx}`}>
                            {content.document && <UserDocument document={content.document} />}
                            {content.image && <UserImage image={content.image} />}
                            {content.text && (
                                <div
                                    className={
                                        "bg-blue-200 rounded-xl rounded-br-none lg:rounded-br-xl py-1.5 px-4 mb-4 prose prose-zinc max-w-[calc(100vw-1rem)] lg:max-w-[65ch]"
                                    }
                                >
                                    <Markdown>{content.text}</Markdown>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div
                    className={
                        "relative hidden lg:block lg:w-[24px] lg:h-[24px] lg:ml-[14px] lg:mt-2"
                    }
                >
                    <AvatarPixel
                        name={user.name}
                        colors={["#5570af", "#146A7C", "#b37a20", "#88417c", "#C20D90"]}
                        size={24}
                        square={false}
                        title={user.name}
                    />
                    <div
                        className={
                            "absolute w-full h-full left-0 top-[-1px] text-md text-zinc-50 shadow-sm font-black text-center"
                        }
                    >
                        {user.name.charAt(0)}
                    </div>
                </div>
            </div>
        </div>
    );
};
